export default __webpack_public_path__ + "static/media/sleepless.5486e3d2.png";